"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnexDumper = void 0;
const date_fns_1 = require("date-fns");
const EnexDumperOptions_1 = require("./EnexDumperOptions");
const NoteDumper_1 = require("./NoteDumper");
class EnexDumper {
    constructor(writer, options = new EnexDumperOptions_1.EnexDumperOptions()) {
        this.writer = writer;
        this.options = options;
        this.noteDumps = [];
        this.done = new Promise((resolve) => this.resolve = resolve);
        writer.write(`<?xml version="1.0" encoding="UTF-8"?>
          <!DOCTYPE en-export SYSTEM "http://xml.evernote.com/pub/evernote-export3.dtd">
          <en-export export-date="${date_fns_1.format(new Date(), options.dateFormat)}" application="${options.exportApplication}" version="${options.exportApplicationVersion}">`);
    }
    next(note) {
        this.noteDumps.push(NoteDumper_1.dumpNote(note, this.options).then((notestr) => {
            try {
                return this.writer.write(notestr);
            }
            catch (error) {
                console.log(`Error ${error} while writing dump ${notestr}`);
            }
        }));
    }
    error(error) {
        console.log(error);
        this.complete();
    }
    complete() {
        Promise.all(this.noteDumps).then(() => {
            try {
                return this.writer.write('</en-export>').then(() => { return this.writer.close(); });
            }
            catch (error) {
                console.log(`Error ${error} while completing after dumping ${this.noteDumps.length} notes`);
            }
        }).then(() => {
            if (this.resolve)
                this.resolve();
        });
    }
}
exports.EnexDumper = EnexDumper;
